import { localeNo } from '@mobiscroll/react';

// Base Mobiscroll options
export const mobiscrollOptions = {
    locale: localeNo,
    theme: 'ios',
    themeVariant: 'light'
};

// Color palette for events
export const eventColors = [
    '#ff0000', // Red
    '#FFEB3C', // Bright Yellow
    '#CDBE00', // Off-Yellow/Mustard
    '#FF9900', // Orange
    '#A04000', // Dark Orange/Rust
    '#FF99FF', // Soft Pink
    '#C71585', // Raspberry
    '#9C26B0', // Purple
    '#4B0082', // Indigo
    '#03A9F4', // Bright Blue
    '#000080', // Navy Blue
    '#009788', // Teal
    '#66FFCC', // Mint
    '#4CAF50', // Green
    '#1B5E20', // Dark Green
    '#795548', // Brown
    '#3E2723'  // Dark Brown
];

// Busy color for private events
export const busyColor = '#ff0000';

// View settings for timeline
export const getViewSettings = (zoomLevel) => ({
    timeline: {
        type: 'year',
        weekNumbers: true,
        rowHeight: 'variable',
        timeCellStep: zoomLevel
    }
});

// Zoom levels configuration
export const zoomLevels = [360, 480, 720, 1440];

// Invalid resources configuration
export const invalidResources = [{
    recurring: {
        repeat: 'daily'
    },
    resource: ['100', '101', '1001'] // disable the parent resources
}, {
    resource: ['11', '1002'] // disable Rentman resources specifically
}];

// Calendar marked dates (holidays, etc.)
export const calendarMarkedDates = [
    new Date(2020, 2, 15),
    new Date(2020, 2, 22),
    {
        start: new Date(2020, 2, 23),
        end: new Date(2020, 2, 24),
        color: 'red'
    },
    {
        color: 'green',
        recurring: { repeat: 'yearly', month: 12, day: 24 }
    }
];

// Event status options
export const eventStatusOptions = [
    { value: 'busy', text: 'Busy' },
    { value: 'free', text: 'Free' },
    { value: 'tentative', text: 'Tentative' }
];

// Default event settings
export const defaultEventSettings = {
    allDay: true,
    status: 'busy',
    editable: false,
    busy: false
};
